import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Button } from 'react-bootstrap'
import AnalyticFlagChoice from './AnalyticFlagChoice'
import renderDescription from 'shared/render-description'

export const ANALYTIC_FLAG_LABELS = { include: 'Is Flagged', exclude: 'Is Not Flagged' }

// One analytic's unresolved flag as a filter in the AND/OR group builder, with the same Off,
// Include and Exclude as the grid's analytic header. Unlike the header, it saves to the leaf
// rather than to the View's analytics.
const AnalyticFlagFilterPopover = ({ column, params, setParams, onClose, onSetHandleApply, canEdit = true }) => {
  const [flag, setFlag] = useState(params.analyticFlag || null)

  const apply = () => {
    setParams((current) => ({ ...current, analyticFlag: flag }))
    onClose?.()
  }

  useEffect(() => {
    onSetHandleApply?.(apply)
  }, [flag]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      <div className="mb-3">
        <strong>{column.name}</strong>
        {column.description && (
          <div className="small text-muted">{renderDescription(column.description, column.column_sources)}</div>
        )}
      </div>
      <hr />
      <AnalyticFlagChoice value={flag} onChange={setFlag} disabled={!canEdit} />
      <div className="mt-4 d-flex justify-content-end">
        <Button variant="primary" size="sm" onClick={canEdit ? apply : onClose}>
          {canEdit ? 'Apply' : 'Close'}
        </Button>
      </div>
    </div>
  )
}

AnalyticFlagFilterPopover.propTypes = {
  column: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  setParams: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  onSetHandleApply: PropTypes.func,
  canEdit: PropTypes.bool
}

export default AnalyticFlagFilterPopover
